import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.804 2.283a.75.75 0 0 0-.336.195l-2 2a.75.75 0 0 0 0 1.062l.47.468-3.572 3.572c-.83-.534-1.773-.808-2.709-.691-1.183.147-2.32.72-3.187 1.587a.75.75 0 0 0 0 1.062l3.468 3.468-5.467 5.468a.75.75 0 1 0 1.062 1.062L9 16.07l3.468 3.468a.75.75 0 0 0 1.062 0c.868-.868 1.44-2.004 1.588-3.187.117-.936-.158-1.879-.692-2.709L18 10.07l.469.469a.75.75 0 0 0 1.062 0l2-2a.75.75 0 0 0 0-1.062l-5-5a.75.75 0 0 0-.726-.194"
    }, null, -1)
  ])))
}
export default { render: render }